//
// Generated class ProxyPaymentInstallment
//

/// <reference path="ProxyPaymentInstallment_ManagedObject.ts" />

class ProxyPaymentInstallment extends ProxyPaymentInstallment_ManagedObject
{

}
